<div class="fs-user-navbar">
  <div class="fs-user-toggle" [matMenuTriggerFor]="beforeMenu" [class.fs-user-toggle--active]="(store$ | async)?.user">
    <fa-icon [icon]="faUserCircle"></fa-icon>
    <label *ngIf="!noName && (store$ | async)?.user">{{ (store$ | async)?.user?.fullname }}</label>
  </div>
  <mat-menu #beforeMenu="matMenu" xPosition="before" class="fs-user-menu">
    <!-- Navigační položky -->
    <button
      mat-menu-item
      class="fs-menu-item fs-menu-item--with-badge"
      (click)="openNotifications($event)"
      (mousedown)="handleNotificationsMouseDown($event)"
      *ngIf="(notificationsState$ | async)?.items?.length"
    >
      <fa-icon [icon]="faBell"></fa-icon>
      <span class="fs-menu-item__label">Notifikace</span>
      <small class="fs-menu-item__badge" *ngIf="(notificationsState$ | async)?.unreadCount">{{
        (notificationsState$ | async)?.unreadCount
      }}</small>
    </button>

    <button mat-menu-item class="fs-menu-item" (click)="openChangelogs()">
      <fa-icon [icon]="faQuestionCircle"></fa-icon>
      <span>Co je nového</span>
    </button>

    <ng-container *ngIf="isAndroid">
      <mat-divider></mat-divider>
      <div class="fs-menu-apps-label" (click)="$event.stopPropagation()">Aplikace ke stažení</div>
      <a *ngIf="canDownloadSaunaClub(store$ | async)" mat-menu-item class="fs-menu-item" href="/static/apk/FinsoftApp.apk">
        <fa-icon [icon]="faDownload"></fa-icon>
        <span>SaunaClub</span>
      </a>
      <a mat-menu-item class="fs-menu-item" href="/static/apk/finsoft.apk">
        <fa-icon [icon]="faDownload"></fa-icon>
        <span>FinSoft Reader</span>
      </a>
    </ng-container>

    <mat-divider></mat-divider>

    <button mat-menu-item class="fs-menu-item fs-menu-item--danger" (click)="logOut()">
      <fa-icon [icon]="faPowerOff"></fa-icon>
      <span>Odhlásit se</span>
    </button>

    <!-- Verze -->
    <div class="fs-menu-version" (click)="$event.stopPropagation()">
      <fs-version-display></fs-version-display>
    </div>
  </mat-menu>
</div>
